module.exports = __webpack_public_path__ + "img/sign-24.a1adb95c.jpg";